document.addEventListener("DOMContentLoaded", initImageLoad);
document.addEventListener("htmx:afterSwap", initImageLoad);

function initImageLoad() {
    document.querySelectorAll("[loading=lazy]").forEach((image) => {
        if (image.complete) return;

        const endOpacity = getComputedStyle(image).opacity;

        image.addEventListener("load", imageLoadHandler, { once: true });

        image.classList.add("is-fade-loading");

        function imageLoadHandler(e) {
            image.classList.remove("is-fade-loading");
            image.animate(
                {
                    opacity: [0, Number(endOpacity)],
                },
                600,
            );
        }
    });
}
